function StartScreen({numQuestions, dispatch}) {
    return (
        <div className="start">
            <h2>Welcome to the Hydraulic Fracturing Water Quiz!</h2>
            <h3>{numQuestions} questions to test your knowledge about the massive quantities of water used in Colorado hydraulic fracturing (fracking) operations.</h3>
            <button className="btn btn-right" onClick={() => dispatch({type: 'start'})}>Start Quiz</button>
        </div>
    )
}

export default StartScreen
